import { useCallback, useEffect, useMemo, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router';
import './styles/base.css';
import './styles/app.css';
import { SiteFooter, SiteHeader } from './components/SiteChrome/SiteChrome.tsx';
import { Home } from './pages/Home.tsx';
import { Call } from './pages/Call.tsx';
import { Record } from './pages/Record.tsx';
import { NotFound } from './pages/NotFound.tsx';
import { JeffAudio } from './lib/audio.ts';

export function App() {
  // One audio engine for the session. It stays completely inert — no
  // AudioContext, no fetches — until a user gesture unlocks it.
  const audio = useMemo(() => new JeffAudio(), []);
  const [muted, setMuted] = useState(() => audio.muted);

  useEffect(() => () => audio.dispose(), [audio]);

  const toggleMute = useCallback(() => {
    const next = !muted;
    audio.setMuted(next);
    setMuted(next);
  }, [audio, muted]);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="app">
        <SiteHeader muted={muted} onToggleMute={toggleMute} />
        <Routes>
          <Route path="/" element={<Home audio={audio} />} />
          <Route path="/call/:id" element={<Call />} />
          <Route path="/record" element={<Record />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <SiteFooter />
      </div>
    </BrowserRouter>
  );
}

/** Client-side navigation should behave like a page load, not a jump-cut. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
